import { GdsServiceProductStatus, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { getTotalPrice } from '../../../utils';
import { getActualProduct, getBaggageName } from '../../../ServiceSummary/utils';
export function baggageOptionItemFactory({ key, travellerId, gdsServiceRfisc, count, confirmedCount, segmentsGroupsCount, gdsService, products = [], groupType = 'all', isLoading }) {
    var _a;
    let actualCount = count;
    let actualProducts = products.filter(product => product.passengerId === travellerId);
    const serviceId = gdsService.id;
    const included = groupType === 'confirmed' || confirmedCount === count;
    if (groupType === 'booked') {
        actualCount = count - confirmedCount;
        actualProducts = actualProducts.filter(product => product.status === GdsServiceProductStatus.Booked);
    }
    else if (groupType === 'confirmed') {
        actualCount = confirmedCount;
        actualProducts = actualProducts.filter(product => product.status === GdsServiceProductStatus.Ticketed);
    }
    const price = getTotalPrice(actualProducts, product => product.price);
    const dCount = count - confirmedCount;
    return {
        id: serviceId,
        rfisc: gdsServiceRfisc,
        segment: key,
        count: actualCount,
        price,
        included,
        name: getBaggageName(gdsService, actualCount),
        status: (_a = getActualProduct(actualProducts)) === null || _a === void 0 ? void 0 : _a.status,
        iconName: gdsService.baggageType,
        deleteMeta: groupType !== 'confirmed'
            ? {
                serviceId: serviceId,
                passengerId: travellerId,
                segmentId: key,
                count: count - dCount,
                allowedSegments: gdsService.allowedSegments,
                type: OrderAdditionalServiceGdsServiceServiceType.Baggage,
                allSegments: key === 'allSegments'
            }
            : null,
        isLoading
    };
}
